import { configureStore } from "@reduxjs/toolkit";
import reducer from "lib/Reducer";

const store = configureStore({
  reducer,
});

export default store;
